import { noop } from 'lodash';
import { DisabledZoomControls, ViewContext } from './types';
import { returnNull } from '@ardoq/common-helpers';

const FULLSCREEN_KEY = 'fullScreen';
const IS_LEGEND_ACTIVE = 'isLegendActive';
const DEGREES_OF_RELATIONSHIP_SLIDER_MENU_ITEM_ID =
  'slider-degrees-of-relationship';

export const viewSettingsConsts = {
  FULLSCREEN_KEY,
  IS_LEGEND_ACTIVE,
  DEGREES_OF_RELATIONSHIP_SLIDER_MENU_ITEM_ID,
} as const;

export const FIELD_DROPDOWN_OPTION_NAME = 'field_option';

export const DEFAULT_VIEW_CONTEXT: ViewContext = {
  getContainer: returnNull,
  getGraphComponent: returnNull,
  zoomIn: noop,
  zoomOut: noop,
  optimizeLayout: noop,
  toggleLegend: noop,
  isLegendActive: false,
  zoomControls: null,
  zoomControlsDisabledState: DisabledZoomControls.NONE,
};
